export const getPLCCDetailsHtml = (href) => ({
    type: 'GET_PLCC_DETAILS_HTML',
    href,
});
